import decodeHtml from './decodeHtml';

const getStringValue = (value) => {
    if (!value) return '';
    if (typeof value === 'string') return value;
    if (typeof value === 'object' && value !== null) {
        if (value.titre) return String(value.titre);
        if (value.description) return String(value.description);
        if (value.text) return String(value.text);
        return JSON.stringify(value);
    }
    return String(value);
};

export const generateLlmTxt = (project, iaData) => {
    const siteName = project?.name || 'Site web';
    const siteUrl = project?.url || '';
    const secteur = decodeHtml(getStringValue(iaData?.secteur)) || 'Services web';
    const localisation = decodeHtml(getStringValue(iaData?.localisation)) || 'France';
    const localite = decodeHtml(getStringValue(iaData?.localite)) || '';
    const comprehension = decodeHtml(getStringValue(iaData?.comprehension)) || '';
    const motsCles = iaData?.mots_cles || [];
    const pointsForts = iaData?.points_forts || [];
    const clientele = decodeHtml(getStringValue(iaData?.clientele)) || '';
    const propositionValeur = decodeHtml(getStringValue(iaData?.notorie)) || '';

    const lines = [
        `# ${siteName}`,
        `> ${comprehension || `Site web spécialisé dans ${secteur}`}`,
        '',
        `- URL : ${siteUrl}`,
        `- Secteur : ${secteur}`,
        localite ? `- Localité : ${localite}` : null,
        `- Localisation : ${localisation}`,
        clientele ? `- Clientèle cible : ${clientele}` : null,
        propositionValeur ? `- Proposition de valeur : ${propositionValeur}` : null,
        '',
        motsCles.length ? `## Mots-clés` : null,
        motsCles.length ? motsCles.map(m => `- ${decodeHtml(getStringValue(m))}`).join('\n') : null,
        '',
        pointsForts.length ? `## Points forts` : null,
        pointsForts.length ? pointsForts.map(p => `- ${decodeHtml(getStringValue(p))}`).join('\n') : null,
    ];

    return lines.filter(l => l !== null).join('\n');
};

export const generateSchemaOrg = (project, iaData) => {
    const secteur = decodeHtml(getStringValue(iaData?.secteur)) || 'Services web';
    const localisation = decodeHtml(getStringValue(iaData?.localisation)) || 'France';
    const localite = decodeHtml(getStringValue(iaData?.localite)) || '';
    const comprehension = decodeHtml(getStringValue(iaData?.comprehension)) || '';
    const siteName = project?.name || 'Site web';
    const siteUrl = project?.url || '';

    const schema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": siteName,
        "url": siteUrl,
        "description": comprehension || `${siteName} — ${secteur}`,
        "address": {
            "@type": "PostalAddress",
            ...(localite && { "addressLocality": localite }),
            "addressCountry": localisation
        },
        "areaServed": {
            "@type": "Country",
            "name": localisation
        },
        "knowsAbout": secteur
    };

    return JSON.stringify(schema, null, 2);
};

export const generateRichSnippets = (project, iaData) => {
    const siteName = project?.name || 'Site web';
    const siteUrl = project?.url || '';
    const secteur = decodeHtml(getStringValue(iaData?.secteur)) || 'services';

    const nextYear = new Date().getFullYear() + 1;

    return `<!-- Rich Snippets — À adapter puis ajouter dans le <head> de votre site -->
<script type="application/ld+json">
{
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "${siteName}",
  "url": "${siteUrl}",
  "description": "À compléter avec la description de votre activité",
  "image": "${siteUrl}/images/logo.jpg",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "À compléter",
    "addressCountry": "FR"
  },
  "priceRange": "$$",
  "openingHours": "Mo-Fr 09:00-18:00",
  "telephone": "+33 X XX XX XX XX",
  "knowsAbout": "${secteur}"
}
</script>

<!-- Exemple pour un produit / service -->
<!--
<script type="application/ld+json">
{
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Nom du produit ou service",
  "description": "Description détaillée",
  "brand": { "@type": "Brand", "name": "${siteName}" },
  "offers": {
    "@type": "Offer",
    "url": "${siteUrl}/votre-page",
    "priceCurrency": "EUR",
    "price": "À compléter",
    "priceValidUntil": "${nextYear}-12-31",
    "availability": "https://schema.org/InStock"
  }
}
</script>
-->`;
};
